import { useAppSelector } from "@/redux/store/hooks";

const useUser = () => {
  const { registeredUser, unverifiedUser, type } = useAppSelector(
    (state) => state.user
  );

  const isUnverfiedUserLoggedIn = !!unverifiedUser?.token;
  const isRegisteredUserLoggedIn = !!registeredUser?.isLoggedIn;
  const isUserAdmin = registeredUser.profile?.roleName?.indexOf("admin") > -1;
  const isPreviewUser = type === "PreviewUser";

  return {
    isUnverfiedUserLoggedIn,
    isRegisteredUserLoggedIn,
    isUserAdmin,
    isPreviewUser
  };
};

export default useUser;
